import { t } from "i18n-js";
import { getHttpClient, errorDesconocido, handle401 } from "../../../core/utils/httpClient";
import basicRequest, { POST_REQUEST, PUT_REQUEST } from "../../../core/redux/actions/request";

import { notification } from "antd";

const PREFIX = "QUOTE_SHOW";
const getState = (state) => state.quote.show;

const {
    getPattern,

    actionPostPattern,
    actionPutPattern,
    actionDeletePattern,

    requestPattern,

    error,
    loading,
    success,
    reset,
    secondaryError,
    secondaryLoading,
    isSecondaryLoading,
    secondarySuccess,
    secondaryReset: formReset,

    isLoaded,
    isLoading,
    getError,
    getData,

    getSecondarySuccess: getFormSuccess,
    getSecondaryError: getFormError,
} = basicRequest(PREFIX, getState);

export const load = (id) => getPattern("react/quotes/v1/" + id, {}, null);

export { reset, isLoading, isLoaded, getError, getData, getFormSuccess, getFormError, formReset, isSecondaryLoading };

export function download(id) {
    return (dispatch, getState) => {
        const cliente = getHttpClient(dispatch, getState());
        cliente.then((axios) => {
            axios
                .get("react/quotes/v1/" + id + "/download.pdf", {
                    responseType: "arraybuffer",
                    headers: { Accept: "application/pdf" },
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "quote.pdf");
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(handle401(dispatch, getState))
                .catch((e) => {
                    if (e.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        if (e.response.status == 404) {
                            alert("Se ha producido un error inesperado ");
                            return;
                        }
                    }

                    errorDesconocido();
                });
        });
    };
}

/**
 * PATRON COMPLEJO: Analizarlo, en el success quiere hacer success del primario y del secundario a la vez
 */

const onSuccess = (message) => (dispatch) => {
    notification.success(message);
    dispatch(secondarySuccess(true));
};

export const updateTask = (quoteId, taskId, form) =>
    requestPattern(
        `react/quotes/v1/${quoteId}/tasks/${taskId}`,
        PUT_REQUEST,
        form,
        secondaryError,
        secondaryLoading,
        success,
        onSuccess({
            message: "Update",
            description: "The Task was updated",
        })
    );

export const createTask = (id, form) =>
    requestPattern(
        `react/quotes/v1/${id}/tasks`,
        POST_REQUEST,
        form,
        secondaryError,
        secondaryLoading,
        success,
        onSuccess({
            message: "Update",
            description: "The Task was created",
        })
    );

/**
 * Fin patron complejo
 */

export const updateStatus = (id, form) =>
    actionPutPattern("react/quotes/v1/" + id + "/update-status", form, {
        message: "Update",
        description: "The Quote was updated",
    });

export const updatePrices = (id) =>
    actionPutPattern(
        "react/quotes/v1/" + id + "/update-prices",
        {},
        {
            message: "Update",
            description: "The Quote was updated",
        }
    );

export const removeTask = (id, taskId) =>
    actionDeletePattern(
        "react/quotes/v1/" + id + "/tasks/" + taskId,
        {},
        {
            message: "Delete",
            description: "The Task was deleted",
        }
    );

export const acceptTask = (id, taskId, form) =>
    actionPutPattern("react/quotes/v1/" + id + "/tasks/" + taskId + "/accept", form, {
        message: "Update",
        description: "The Task was accepted",
    });

export const rejectTask = (id, taskId, form) =>
    actionPutPattern("react/quotes/v1/" + id + "/tasks/" + taskId + "/reject", form, {
        message: "Update",
        description: "The Task was rejected",
    });

export const createBoxFolder = (id) => actionPostPattern("react/quotes/v1/" + id + "/box-folder/", {});
